<template>
  <section class="flex justify-center">
    <div class="w-full py-8 md:px-8">
      <div class="px-2 pt-2">
        <!-- Ícone -->
        <div class="flex justify-center mb-4">
          <img
            :src="iconUrl"
            class="max-h-44 max-w-60 rounded-lg"
            alt="Sucesso"
          />
        </div>

        <!-- Título -->
        <div class="tittle mb-2 px-4 text-center">
          <h1 class="text-sm font-semibold">{{ displayTitle }}</h1>
        </div>

        <!-- Mensagem -->
        <div class="py-2 mt-12 bg-white border-2 border-gray-200 rounded-lg">
          <div class="mb-2 px-4 text-center">
            <h1 class="text-sm font-bold mb-4">I M P O R T A N T E</h1>
            <p class="text-sm font-normal" v-html="displayMessage"></p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'SuccessScreen',
  props: {
    title: {
      type: String,
      default: null
    },
    message: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    participant: {
      type: Object,
      default: null
    }
  },
  setup(props) {
    const displayTitle = computed(() => {
      if (props.title) {
        // Substitui {{name}} pelo nome do participante
        return props.title.replace('{{name}}', props.participant?.name || '');
      }
      return `${props.participant?.name || 'Sua'}, inscrição foi realizada com sucesso!`;
    });

    const displayMessage = computed(() => {
      if (props.message) {
        // Permite HTML no message (sanitizado no backend)
        return props.message;
      }
      return 'Acompanhe seu e-mail e WhatsApp para mais informações sobre o evento.';
    });

    const iconUrl = computed(() => {
      if (props.icon) {
        return props.icon;
      }
      // Imagem padrão de sucesso (se existir no projeto)
      try {
        return require('@/assets/sucess.png');
      } catch {
        // Fallback para um ícone SVG inline se a imagem não existir
        return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iNTAiIGN5PSI1MCIgcj0iNTAiIGZpbGw9IiMxMEI5ODEiLz48cGF0aCBkPSJNMzAgNTBMNDUgNjVMNzAgMzUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9zdmc+';
      }
    });

    return {
      displayTitle,
      displayMessage,
      iconUrl
    };
  }
};
</script>

<style scoped>
.tittle h1 {
  color: #1e293b;
}
</style>
